import { ADD_USER,ADD_GRADES,ADD_TOKEN,ADD_ASSIGNED_SCRIPTS, ADD_MARKED_SCRIPTS,ADD_SELECTED_SUBJECT,ADD_AVAILABLE_SCRIPTS, ADD_USERS } from "../constants/action-types";

export function addUsers(payload){
  return  { type: ADD_USERS, payload: payload };
}

export  function addAvailableScripts(payload){
  return  { type: ADD_AVAILABLE_SCRIPTS, payload: payload };
}

export function addToken(payload){
  return  { type: ADD_TOKEN, payload: payload };
}

export function addUser(payload){
  return  { type: ADD_USER, payload: payload };
}

export function addGrades(payload){
  return  { type: ADD_GRADES, payload: payload };
}

export function addAssignedScripts(payload){
  return  { type: ADD_ASSIGNED_SCRIPTS, payload: payload };
}

export function addMarkedScripts(payload){
  return  { type: ADD_MARKED_SCRIPTS, payload: payload };
}

export function addSelectedSubject(payload){
  return  { type: ADD_SELECTED_SUBJECT, payload: payload };
}



